import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'
import moment from 'moment'

const getDefaultStateForAccounts = () => {
  return {
    fy_by_date:{
      fy:"",
      id:""
    },
    accounts: [],
    accounts_for_fy:[],
    vouchers:[],
    voucher:{},
    is_voucher_created:"",
    is_voucher_voided:null,
    voucher_filter:{
      keyword:"",
      active_only:"1"
    },
    fys:[],
    is_fy_created:null,
    data:{},
    is_created:null,
    is_updated:null,
    is_deleted:null,
    active_accounts:[],
    account_types:[],
    filter:{
        keyword:"",
        active_only:"1",
        account_id:null
    }
  }
}

// state
const state = getDefaultStateForAccounts()

const getters = {

}

// mutations
const mutations = {
    SET_FY_BY_DATE(state, data)
    {
      state.fy_by_date = data
    },
    SET_VOUCHER_VOIDED(state, data)
    {
      state.is_voucher_voided = data
    },
    SET_ACCOUNTS_FOR_FY(state, data)
    {
      state.accounts_for_fy = data
    },
    SET_FINANCIAL_YEARS(state, data)
    {
      state.fys = data
    },
    SET_ACCOUNT_TYPES(state, data)
    {
      state.account_types = data
    },
    FETCH_ALL(state, data){
      if(data)
      {
        state.accounts = data
      }
    },
    FETCH_ALL_VOUCHERS(state, data){
      if(data)
      {
        data.forEach(function(element) {
            element.voucher_date = (element.voucher_date != null && element.voucher_date != '') ? (moment(element.voucher_date).format('DD/MM/YYYY')) : '-'
        });

        state.vouchers = data
      }
    },
    RESET_STATE_FOR_ACCOUNTS (state) {
      Object.assign(state, getDefaultStateForAccounts())
    },
    FETCH_ACTIVE(state, data)
    {
        if(data)
        {
            state.active_accounts = data.data
        }
    },
    SET_IS_VOUCHER_CREATED(state, data) 
    {
      state.is_voucher_created = data
    },
    SET_IS_DELETED(state, data)
    {
      state.is_deleted = data
    },
    SET_IS_CREATED(state, data)
    {
      state.is_created = data
    },
    SET_FY_CREATED(state, data)
    {
      state.is_fy_created = data
    },
    SET_IS_UPDATED(state, data)
    {
      state.is_updated = data
    },
    FETCH_VOUCHER(state, data)
    {
      state.voucher = data
    },
    FETCH(state, data)
    {
        if(data)
        {
          if(data.account_type)
          {
              data.account_type_obj  = {code: data.account_type, name:data.account_type_name}
          }
          if(data.currency_code)
          {
              data.currency  = {code: data.currency_code}
          }

          if(data.parent_id)
          {
              data.parent_account  = {id: data.parent_id, code:data.parent_code, name:data.parent_name, display_name:data.parent_display_name}
          }

          state.data = data
        }
    }
}

// actions
const actions = {
    async delete({ commit, dispatch }, data) {
    await axios
        .post(apiRoutes['DELETE_ACCOUNT'], data, authHeader())
        .then(function (response) {
          if(response.data.code == 1)
          {
                commit('SET_IS_DELETED', 1);
                Vue.notify({
                    group: 'notify',
                    type: 'success',
                    text: "Account has been deleted!",
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
          }
          else
          {
              let errors = response.data.data.errors
              commit('SET_IS_DELETED', 0);

              if(Array.isArray(errors))
              {
                let msg = errors.join("\n")

                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
          }

        })
        .catch((error) => {
            if (error.response) {
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.message,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            }
            else
            {
                //console.log("Problem submitting New Post", error);
                alert("Problem Creating Account")
            }
        });
    },
    async update({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['UPDATE_ACCOUNT'], data, authHeader())
            .then(function (response) {
              if(response.data.code == 1)
              {
                    let doc_number  = response.data.data.code
                    commit('SET_IS_UPDATED', 1);
                    Vue.notify({
                        group: 'notify',
                        type: 'success',
                        text: 'Account (' + doc_number + ')' + " has been updated!",
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
              }
              else
              {
                  let errors = response.data.data.errors
                  commit('SET_IS_UPDATED', 0);
  
                  if(Array.isArray(errors))
                  {
                    let msg = errors.join("\n")
  
                      Vue.notify({
                          group: 'notify',
                          type: 'error',
                          text: msg,
                          max: 5,
                          duration: 5000,
                          speed: 300
                      })
                  }
              }
  
            })
            .catch((error) => {
                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
                else
                {
                    alert("Problem Creating Account")
                }
            });
    },
    async voidVoucher({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['VOID_VOUCHER'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  commit('SET_VOUCHER_VOIDED', 1);
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: "Voucher has been voided!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
            }
            else
            {
                let errors = response.data.data.errors
                commit('SET_VOUCHER_VOIDED', 0);

                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")

                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: msg,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
            }

          })
          .catch((error) => {
              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  alert("Problem Creating Account")
              }
          });
  },
    async createVoucher({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['CREATE_VOUCHER'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  let doc_number  = response.data.data.code
                  commit('SET_IS_VOUCHER_CREATED', 1);
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: 'Voucher (' + doc_number + ')' + " has been created!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
            }
            else
            {
                let errors = response.data.data.errors
                
                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")
                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_VOUCHER_CREATED', 0);
            }

          })
          .catch((error) => {
              if (error.response) 
              {
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  alert("Problem Creating Voucher")
              }
          });
    },
    async create({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['CREATE_ACCOUNT'], data, authHeader())
            .then(function (response) {
              if(response.data.code == 1)
              {
                    let doc_number  = response.data.data.code
                    commit('SET_IS_CREATED', 1);
                    Vue.notify({
                        group: 'notify',
                        type: 'success',
                        text: 'Account (' + doc_number + ')' + " has been created!",
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
              }
              else
              {
                  let errors = response.data.data.errors
                  
                  if(Array.isArray(errors))
                  {
                    let msg = errors.join("\n")
                    Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  }
                  commit('SET_IS_CREATED', 0);
              }
  
            })
            .catch((error) => {
                if (error.response) 
                {
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
                else
                {
                    alert("Problem Creating Account")
                }
            });
    },
    async createNewFY({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['CREATE_NEW_FY'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  let fy  = response.data.data.code
                  commit('SET_FY_CREATED', 1);
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: 'Financial year (' + fy + ')' + " has been created!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
            }
            else
            {
                let errors = response.data.data.errors
                
                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")
                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_FY_CREATED', 0);
            }

          })
          .catch((error) => {
              if (error.response) 
              {
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  alert("Problem Creating Account")
              }
          });
  },
  resetState({ commit, dispatch }, payload) {
      commit("RESET_STATE_FOR_ACCOUNTS")
  },
  async getFyByDate({ commit }, data)
    {
        return axios.post(apiRoutes['GET_FY_BY_DATE'], data, authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            commit('SET_FY_BY_DATE', response.data.data)
          } else {
            commit('SET_FY_BY_DATE', {})
          }
        })
        .catch(error => {
          if (error.response) {
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
    },
    async fetchActive({ commit }, data)
    {
        return axios.post(apiRoutes['ACCOUNT_ACTIVE_LIST'], data, authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            commit('FETCH_ACTIVE', {data:response.data.data})
          } else {
            commit('FETCH_ACTIVE', {data:[]})
          }
        })
        .catch(error => {
          if (error.response) {
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
    },
    fetchFYs({ commit }, data) {
      return axios.post(apiRoutes['GET_FYS'], data, authHeader())
          .then(response => {
            if(response.data.code == 1){
              commit('SET_FINANCIAL_YEARS', response.data.data)
            } else {
              commit('SET_FINANCIAL_YEARS', [])
            }
          })
          .catch(error => {
            if (error.response) {
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
  },
    fetchAccountTypes({ commit }, data) {
        return axios.post(apiRoutes['LIST_ALL_ACCOUNT_TYPES'], data, authHeader())
            .then(response => {
              if(response.data.code == 1){
                commit('SET_ACCOUNT_TYPES', response.data.data)
              } else {
                commit('SET_ACCOUNT_TYPES', [])
              }
            })
            .catch(error => {
              if (error.response) {
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
    quickSearchVouchers({ commit }, data) {
      return axios.post(apiRoutes['QUICK_SEARCH_VOUCHERS'], data, authHeader())
          .then(response => {
            if(response.data.code == 1){
              commit('FETCH_ALL_VOUCHERS', response.data.data)
            } else {
              commit('FETCH_ALL_VOUCHERS', [])
            }
          })
          .catch(error => {
            if (error.response) {
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
  },
  getAccountForFys({ commit }, data) {
    return axios.post(apiRoutes['GET_ACCOUNTS_FOR_FY'], data, authHeader())
        .then(response => {
          if(response.data.code == 1){
            commit('SET_ACCOUNTS_FOR_FY', response.data.data)
          } else {
            commit('SET_ACCOUNTS_FOR_FY', [])
          }
        })
        .catch(error => {
          if (error.response) {
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
},
    quickSearch({ commit }, data) {
        return axios.post(apiRoutes['QUICK_SEARCH_COA'], data, authHeader())
            .then(response => {
              if(response.data.code == 1){
                commit('FETCH_ALL', response.data.data)
              } else {
                commit('FETCH_ALL', [])
              }
            })
            .catch(error => {
              if (error.response) {
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
    fetch({ commit }, data) {
        return axios.post(apiRoutes['RETRIEVE_ACCOUNT'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('FETCH', response.data.data)
              } else {
                commit('FETCH', {})
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
    fetchVoucher({ commit }, data) {
      return axios.post(apiRoutes['RETRIEVE_VOUCHER'], data, authHeader())
          .then(response => {
            if(response.data.code == 1)
            {
              commit('FETCH_VOUCHER', response.data.data)
            } else {
              commit('FETCH_VOUCHER', {})
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
    },
}

export {
    state,
    getters,
    actions,
    mutations
}
